// extracted by mini-css-extract-plugin
module.exports = {"features":"features_features__TpZrm","featuresList":"features_featuresList__M2Mz9"};